import React from "react"

export const TimerDisplay = ({ seconds }) => {
  const totalSeconds = 60
  const progress = (seconds / totalSeconds) * 100
  const circumference = 2 * Math.PI * 18
  const strokeDashoffset = circumference - (progress / 100) * circumference

  const formattedTime = `00:${seconds.toString().padStart(2, "0")}`

  return (
    <div className="timer-display">
      <svg className="timer-circle" width="50" height="50" viewBox="0 0 50 50">
        <circle
          className="timer-circle-bg"
          cx="25"
          cy="25"
          r="18"
          fill="none"
          strokeWidth="4"
        />
        <circle
          className="timer-circle-progress"
          cx="25"
          cy="25"
          r="18"
          fill="none"
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 25 25)"
        />
      </svg>
      <span className="timer-text">{formattedTime}</span>
    </div>
  )
}
